// extracted by mini-css-extract-plugin
export default {"body":"App_body__3bmRq","rwd":"App_rwd__35mPq","ufo":"App_ufo__ivGQJ","alert":"App_alert__-qKl5","screen":"App_screen__5na4K"};